export default __webpack_public_path__ + "static/media/Facturacion-orange.2710cb93.svg";